import { CLSLogType } from "../../enums/log/clsLogType";
import { LogLevelType } from "../../enums/log/logLevelType";
import { Log } from "../../models/logging/log";
import envSettings from "../system/envSettings";

export const initTrackOptions = () => {
  return {
    msg: "Track",
    level: LogLevelType[LogLevelType.info],
    cprNumber: undefined,
    clsRequest: {
      aftaleId: `${envSettings.AFTALEID_CLS_LOG}`,
      requestId: `${envSettings.REQUESTID_CLS_LOG}`,
      modulId: `${envSettings.MODULE_ID_CLS_LOG}`,
      modulNavn: `${envSettings.MODULE_NAME_CLS_LOG}`,
      logType: CLSLogType.AuditLog,
      dataSletSenest: "audit",
      body: undefined,
    },
  } as Log;
};
